export const START_WEBSOCKET = '@@firedrum/START_WEBSOCKET'
export const STOP_WEBSOCKET = '@@firedrum/STOP_WEBSOCKET'
export const WEBSOCKET_DATA_RECEIVED = '@@firedrum/WEBSOCKET_DATA_RECEIVED'
export const SEND_TO_WEBSOCKET = '@@firedrum/SEND_TO_WEBSOCKET'
